<template>
  <div id="placeList">
    <div v-for="genre in genres" :key="genre.id">
      <template v-if="places(genre).length > 0">
        <h2 class="section-title m-4 text-center text-lg">
          {{ $t('tour_category_title', { genreName: genre.name }) }}
        </h2>
        <div>
          <ul class="courselist pl-4">
            <li v-for="place in places(genre).slice(0, genre.maxPlace)" :key="place.id">
              <div class="course">
                <div class="course-info">
                  <div class="float-right pt-2 pr-1">
                    <favorite :place="place" />
                  </div>
                  <h3 class="course-title">
                    {{ place.name }}
                  </h3>
                  <img v-lazy="place.image" class="course-image" />
                  <p class="course-detail" v-html="place.detail"></p>
                </div>
                <div class="course-button m-4">
                  <a class="button-primary block" @click="showModal(place)">
                    {{ $t('tour_display_detail_label') }}
                  </a>
                </div>
              </div>
            </li>
            <li v-if="places(genre).length > genre.maxPlace">
              <div class="course">
                <div class="course-info">
                  <h3 class="course-title text-white">*</h3>
                  <div class="text-center text-gray-500 px-5">
                    <a @click="addPlace(genre)">{{ $t('tour_add_model_cource_title') }}</a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </template>
    </div>

    <PoiModal v-show="modal.show" :closeModal="() => closeModal()">
      <PoiDetail v-show="modal.show" :place="place"  @createItem="createItem" />
    </PoiModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PoiModal from "../molecules/PoiModal"
import PoiDetail from '../molecules/PoiDetail'
import Favorite from '../molecules/Favorite'

export default {
  name: 'PoiList',
  components: {
    PoiModal,
    PoiDetail,
    Favorite
  },
  data () {
    return {
      place: {},
      modal: {
        show: false
      },
      genres: []
    }
  },
  methods: {
    showModal (place) {
      this.place = place
      this.modal.show = true
    },
    closeModal () {
      this.modal.show = false
    },
    createItem (poiId) {
      // GoogleAnalytics
      this.$gtag.event("POIからプラン作成", {
        poi_name: this.place.name
      });
      
      this.$router.push({ name: 'newPlan', query: { poiId: poiId } })
    },
    places (genre) {
      const favoriteGenre = this.$store.getters['genres/getFavoriteGenre']
      if (favoriteGenre !== undefined && genre.id === favoriteGenre.id) {
        return this.$store.getters['favorites/getFavoritedPlaces']
      } else {
        return this.$store.getters['places/getPlacesByGenre'](genre).filter(place => {
          return place.image !== undefined && place.detail !== undefined ? true : false
        })
      }
    },
    addPlace (genre) {
      Object.assign(genre, { maxPlace: genre.maxPlace + 10 })
    }
  },
  computed: {
    ...mapGetters({
      getAllForPlanTop: 'genres/getAllForPlanTop'
    })
  },
  watch: {
    getAllForPlanTop: function (genre) {
      this.genres = []
      for (let i = 0; i < genre.length; i++) {
        this.genres.push({
          id: genre[i].id,
          name: genre[i].name,
          maxPlace: 1000
        })
      }
    }
  }
}
</script>
